const ignoredHosts = ['translate.googleusercontent.com'];

export default host => ignoredHosts.includes(host);
